const MAX_AR_QUANTITY = 10;

/**
 * Builds the selectable Auto-Replenish quantity range for a SKU: 1..min(maxPurchaseQuantity, 10).
 *
 * @param {Object} sku - SKU whose maxPurchaseQuantity bounds the range.
 * @returns {number[]} Ascending quantities from 1 to the capped maximum.
 */
const getArQuantityRange = sku => {
    const max = Number(sku?.maxPurchaseQuantity) || 1;
    const cappedMax = Math.min(max, MAX_AR_QUANTITY);
    const range = [];

    for (let value = 1; value <= cappedMax; value++) {
        range.push(value);
    }

    return range;
};

export { getArQuantityRange };
